export default __webpack_public_path__ + "static/media/manifestationoftheforest.8341bfe4.png";